import React, { FC, ReactNode } from 'react';
import { ReactComponent as Emote } from 'assets/icons/neutral_emote.svg';
import COButton from '../COButton';
import styles from './categoryEmptyState.module.scss';
import { Col, Row } from 'antd';
import { ReactComponent as ArrowRight } from 'assets/icons/arrow_right.svg';
import clsx from 'clsx';

interface EmptyStateScopeProps {
  buttonTitle?: ReactNode;
  handleRedirect: () => void;
  title?: string;
  subString?: string;
  commodityState?: boolean;
}

const EmptyStateScope: FC<EmptyStateScopeProps> = ({
  buttonTitle,
  handleRedirect,
  title,
  subString,
  commodityState = false,
}) => {
  return (
    <div className={styles.emptyStateWrapper}>
      <div>
        <Emote className={styles.emote} />
      </div>
      <div className={styles.title}>{title}</div>
      <div
        className={clsx(styles.subTitle, {
          [styles.widthAlign]: commodityState,
        })}>
        {subString}
      </div>
      {!commodityState && (
        <div className={styles.buttonWrapper}>
          <COButton onClick={handleRedirect} primary>
            <Row align="middle" className={styles.buttonContent}>
              <Col>{buttonTitle}</Col>
              <Col className={styles.buttonArrow}>
                <ArrowRight />
              </Col>
            </Row>
          </COButton>
        </div>
      )}
    </div>
  );
};

export default EmptyStateScope;
